import createHeaders from "@utils/createHeaders";

export const headers = createHeaders ([
  { text: 'No', value: 'number_index', width: '10' },
  { text: 'Nama Merchant/Agregator', value: 'name' },
  { text: 'Send To', value: 'channel_type'},
  { text: 'SFTP', value: 'sftp_ip_address' },
  { text: 'Email', value: 'email', width: '300'  },
  { text: 'Status', value: 'status' },
  { text: 'Action', value: 'action', align: 'center', textAlign: 'text-center', width: '10' },
]);

export const search = {
  status: '',
  email_owner: '',
};
export const defaultItem = {
  name: '',
  channel_type: '',
  file_format: '',
  file_type: '',
  email: '',
  sftp_ip_address: '',
  sftp_username: '',
  sftp_password: '',
  sftp_port: '',
  sftp_path: '',
  status: '',
};
export const editedItem = {
  name: '',
  channel_type: '',
  file_format: '',
  file_type: '',
  email: '',
  sftp_ip_address: '',
  sftp_username: '',
  sftp_password: '',
  sftp_port: '',
  sftp_path: '',
  status: '',
};
